import { Component, ViewChild } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from '../../../services/shared.service';
import { OpenPaylineDetailsArgs, PaylineType, SelectedPaylineArgs } from '../../../models/payroll';
import { Store } from '@ngxs/store';
import { AclService } from '../../../services/acl.service';
import { ClientSelectionState } from '../../../state/ClientSelectionState/ClientSelection.state';
import { PayrollManagement } from '../../../tools/payroll-management';

@Component({
  selector: 'more-payroll-actions-popup',
  templateUrl: './more-payroll-actions-popup.html',
  styleUrls: ['./more-payroll-actions-popup.css'],
  standalone: false
})
export class MorePayrollActionsPopup {
  public params;

  public canViewPeople: boolean = false;

  @ViewChild('moreActionsDropdown', { static: true })
  moreActionsDropdown: NgbDropdown;

  constructor(
    private sharedService: SharedService,
    private store: Store,
    private aclService: AclService,
    private payrollMgmt: PayrollManagement
  ) {
    this.sharedService.closeMoreActionsPopup.subscribe(() => {
      this.moreActionsDropdown.close();
    });
    this.aclService.CurrentUserHasMinimumRole('CSR1').subscribe(result => {
      if (result) {
        this.canViewPeople = result;
      } else {
        this.store.selectOnce(ClientSelectionState.clientCode).subscribe(code => {
          this.aclService
            .CurrentUserAccessCheck('Client Portal Admin', 'EditPeople', code)
            .subscribe(finalResult => {
              this.canViewPeople = finalResult;
            });
        });
      }
    });
  }

  agInit(params) {
    this.params = params;
  }

  public addPayline() {
    this.sharedService.addPayline.next(
      new SelectedPaylineArgs(
        this.params.data.RowId,
        this.params.data.PaylineId,
        this.params.data.PersonId,
        this.params.rowIndex
      )
    );
  }

  public openPersonModal() {
    this.sharedService.openPayrollPersonModal.next(this.params.data.PersonId);
  }

  // emit event to payroll grid component to open payline details
  public openPaylineDetails(params) {
    const args = new OpenPaylineDetailsArgs(
      params.data.RowId,
      params.data.PaylineId,
      params.data.PersonId,
      params.rowIndex,
      params.data.NeedsCalculation,
      params.data.IsDirty,
      !this.payrollMgmt.isPaylineEditable(params.data.PaylineType)
    );

    this.sharedService.openPaylineDetails.next(args);
  }
}
